import PropTypes from "prop-types";

function PauseIcon(props) {
    const { className, size = 24, color = "currentColor" } = props;

    return (
        <svg
            width={size}
            height={size}
            fill="none"
            viewBox="0 0 24 24"
            className={className}
        >
            <path
                fill={color}
                fillRule="evenodd"
                d="M6 5a1 1 0 00-1 1v12a1 1 0 001 1h3.6a1 1 0 001-1V6a1 1 0 00-1-1H6zm8.4 0a1 1 0 00-1 1v12a1 1 0 001 1H18a1 1 0 001-1V6a1 1 0 00-1-1h-3.6z"
                clipRule="evenodd"
            />
        </svg>
  );
}

export default PauseIcon;

PauseIcon.propTypes = {
    className: PropTypes.string,
    size: PropTypes.number,
    color: PropTypes.string,
}